import { forwardRef } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { navbarLinks } from "../constants";

import logoLight from "../assets/logo.png";
import logoDark from "../assets/logo-dark.svg";

import { cn } from "../utils/cn";

import PropTypes from "prop-types";

export const Sidebar = forwardRef(({ collapsed, setCollapsed }, ref) => {
    const location = useLocation();

    const handleLinkClick = () => {
        // Only collapse the sidebar on mobile devices
        if (window.innerWidth < 768) {
            setCollapsed(true);
        }
    };

    return (
        <aside
            ref={ref}
            className={cn(
                "fixed z-[100] flex h-full flex-col overflow-x-hidden border-r border-_gray_lite bg-_white shadow-sm [transition:_width_300ms_cubic-bezier(0.4,_0,_0.2,_1),_left_300ms_cubic-bezier(0.4,_0,_0.2,_1),_background-color_150ms_cubic-bezier(0.4,_0,_0.2,_1),_border_150ms_cubic-bezier(0.4,_0,_0.2,_1)]",
                collapsed ? "md:w-[70px] md:items-center" : "md:w-[240px]",
                collapsed ? "max-md:-left-full" : "max-md:left-0",
            )}
        >
            {/* Logo Header Section */}
            <div className="flex items-center justify-start border-b border-_gray_lite p-4">
                {collapsed ? (
                    <img
                        src={logoDark}
                        alt="Logoipsum"
                        className="h-10 w-10 object-contain dark:hidden"
                    />
                ) : (
                    <img
                        src={logoDark}
                        alt="Logoipsum"
                        className="w-2/3 object-contain dark:hidden"
                    />
                )}
                <img
                    src={logoLight}
                    alt="Logoipsum"
                    className="hidden dark:block w-3/4"
                />
            </div>

            {/* Navigation Section */}
            <div className="flex w-full flex-col gap-y-6 overflow-y-auto overflow-x-hidden p-3 pt-6 [scrollbar-width:_thin]">
                {navbarLinks.map((navbarLink) => (
                    <nav
                        key={navbarLink.title}
                        className={cn("flex flex-col", collapsed && "md:items-center")}
                    >
                        <p className={cn(
                            "mb-2 px-2 text-xs font-medium uppercase tracking-wider text-_dark_lite",
                            collapsed && "md:w-[45px] md:text-center md:text-[8px]"
                        )}>
                            {navbarLink.title}
                        </p>
                        
                        {navbarLink.links.map((link) => (
                           <NavLink
                           key={link.label}
                           to={link.path}
                           onClick={handleLinkClick}
                           className={({ isActive }) => cn(
                               "mb-1 flex items-center gap-3 rounded-md px-3 py-2.5 transition-all duration-200",
                               collapsed && "md:justify-center md:px-1",
                               isActive && (
                                   // Only consider it active if the paths match exactly or for special cases
                                   location.pathname === link.path || 
                                   // For index routes, be more specific
                                   (link.path === "/admin" && location.pathname === "/admin/")
                               )
                                   ? "bg-_blue/10 text-_blue font-medium" 
                                   : "text-_dark hover:bg-_gray_hover"
                           )}
                       >
                                <link.icon
                                    size={20}
                                    className={cn(
                                        "flex-shrink-0", 
                                        collapsed && "md:mx-auto"
                                    )}
                                />
                                {!collapsed && <p className="text-sm whitespace-nowrap">{link.label}</p>}
                            </NavLink>
                        ))}
                    </nav>
                ))}
            </div>
        </aside>
    );
});

Sidebar.displayName = "Sidebar";

Sidebar.propTypes = {
    collapsed: PropTypes.bool,
};